// AlignUI · иллюстрация пустого состояния: планшет с закладкой
//
// Перенесена скриптом из набора дизайн-системы, руками не правится. Цвета заменены на
// семантические классы: под ними лежат переменные `--illustration-*`, у которых в тёмной
// теме своя ступень серого. Без этого картинка светилась бы белым пятном на тёмном экране.

import type { SVGProps } from 'react';

export function IllustrationЗаявки(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 148 148' fill='none' {...props}>
      <rect className='fill-illustration-weak-100' width='148' height='148' rx='74' />
      <rect
        className='fill-illustration-sub-300 stroke-illustration-strong-400'
        x='46.5712'
        y='39.757'
        width='65.5709'
        height='76.9585'
        rx='5.41989'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <rect
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        x='35.8591'
        y='31.284'
        width='65.5709'
        height='76.9585'
        rx='5.41989'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M51.808 65.5308L60.0929 73.8674'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M60.1194 65.5567L51.7827 73.8418'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M77.1957 65.6097L85.4808 73.9461'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M85.5065 65.6358L77.1699 73.9209'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='stroke-illustration-strong-400'
        d='M56.9412 82.4019L78.4895 82.4685'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-sub-300 stroke-illustration-strong-400'
        d='M51.6311 50.4029C51.5977 50.4075 51.5637 50.4006 51.5348 50.3835L46.6445 46.8464C46.5996 46.8164 46.5411 46.8164 46.4962 46.8464L41.6059 50.3835C41.5352 50.4244 41.4445 50.4002 41.4034 50.3294C41.3896 50.3052 41.3827 50.2778 41.3836 50.25V38.6304C41.3836 37.8113 42.0471 37.1473 42.8656 37.1473H50.2751C51.0936 37.1473 51.7571 37.8113 51.7571 38.6304V50.2351C51.7684 50.3163 51.7122 50.3913 51.6311 50.4029Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-soft-200 stroke-illustration-strong-400'
        d='M35.2903 111.383C41.5202 111.383 46.5706 106.332 46.5706 100.103C46.5706 93.8726 41.5202 88.8223 35.2903 88.8223C29.0604 88.8223 24.01 93.8726 24.01 100.103C24.01 106.332 29.0604 111.383 35.2903 111.383Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-strong-400 stroke-illustration-strong-400'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M39.3974 100.903C39.0826 101.392 38.6635 101.873 38.143 102.354C37.3139 103.083 36.4288 103.746 35.4952 104.333L35.2925 104.46L35.0897 104.336C34.1486 103.756 33.2589 103.092 32.4268 102.345C31.5099 101.473 30.8759 100.552 30.6021 99.5971C31.5901 98.8587 32.917 98.5576 34.1078 98.898C34.9066 99.1266 35.6102 99.5986 36.3198 100.03C37.031 100.463 37.7875 100.87 38.6151 100.948C38.8739 100.972 39.1402 100.957 39.3974 100.903Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-weak-100 stroke-illustration-strong-400'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M40.1327 98.5334C40.1327 99.3701 39.8876 100.146 39.3973 100.903C39.1401 100.957 38.8738 100.972 38.6151 100.948C37.7875 100.87 37.0309 100.463 36.3198 100.03C35.6102 99.5986 34.8306 99.8256 34.0317 99.5971C32.8409 99.2566 31.5901 98.8587 30.602 99.5971C30.5007 99.246 30.4492 98.8905 30.4492 98.5319C30.4522 97.2503 31.3147 96.1337 32.5433 95.8281C33.5676 95.5724 34.6267 95.937 35.2909 96.7253C35.8054 96.111 36.5665 95.7449 37.382 95.7449H37.3865C38.1143 95.7449 38.8118 96.0384 39.3262 96.5604C39.8437 97.0839 40.1327 97.7936 40.1327 98.5334Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-sub-300 stroke-illustration-strong-400'
        d='M74.0002 46.0751C81.5938 46.0751 87.7497 39.9192 87.7497 32.3256C87.7497 24.732 81.5938 18.5761 74.0002 18.5761C66.4066 18.5761 60.2507 24.732 60.2507 32.3256C60.2507 39.9192 66.4066 46.0751 74.0002 46.0751Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-strong-400'
        d='M79.0421 33.447C79.0421 36.3086 76.7844 38.6285 73.9997 38.6285C71.215 38.6285 68.9573 36.3086 68.9573 33.447C68.9573 32.098 69.4613 30.8671 70.2854 29.9454L70.4828 29.7367L73.9997 26.0224L77.5414 29.7622L77.7158 29.9454C78.538 30.8671 79.0421 32.098 79.0421 33.447Z'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M106.986 72.5468C112.908 72.5468 117.709 67.7463 117.709 61.8247C117.709 55.903 112.908 51.1025 106.986 51.1025C101.065 51.1025 96.2643 55.903 96.2643 61.8247C96.2643 67.7463 101.065 72.5468 106.986 72.5468Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-strong-400'
        d='M106.987 63.4837C108.681 63.4837 110.055 62.1101 110.055 60.4157C110.055 58.7213 108.681 57.3477 106.987 57.3477C105.293 57.3477 103.919 58.7213 103.919 60.4157C103.919 62.1101 105.293 63.4837 106.987 63.4837Z'
      />
      <mask
        id='mask0_3860_5972'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='95'
        y='50'
        width='24'
        height='24'
      >
        <path
          className='fill-illustration-soft-200 stroke-illustration-strong-400'
          d='M106.987 72.5463C112.908 72.5463 117.709 67.7458 117.709 61.8242C117.709 55.9025 112.908 51.1021 106.987 51.1021C101.065 51.1021 96.2646 55.9025 96.2646 61.8242C96.2646 67.7458 101.065 72.5463 106.987 72.5463Z'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </mask>
      <g mask='url(#mask0_3860_5972)'>
        <path
          className='fill-illustration-strong-400'
          d='M106.986 78.1814C111.045 78.1814 114.335 74.8912 114.335 70.8326C114.335 66.774 111.045 63.4839 106.986 63.4839C102.928 63.4839 99.6377 66.774 99.6377 70.8326C99.6377 74.8912 102.928 78.1814 106.986 78.1814Z'
        />
      </g>
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M25.5716 42.7029C25.5716 42.7029 19.5642 40.9133 17.7603 46.8941C19.5641 40.9133 13.5691 39.0829 13.5691 39.0829C13.5691 39.0829 19.5765 40.8724 21.3803 34.8916C19.5765 40.8724 25.5716 42.7029 25.5716 42.7029Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M135.606 96.2403C135.606 96.2403 130.476 102.259 136.456 107.392C130.476 102.259 125.304 108.243 125.304 108.243C125.304 108.243 130.435 102.224 124.454 97.0905C130.435 102.224 135.606 96.2403 135.606 96.2403Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
